import * as Sentry from "@sentry/browser"
import type { EditorAnalyticsPort } from "@shared/unified-tiptap/analytics/instrument"
import type { LessonEditIds } from "cc-frontend/lib/actions/lesson/lesson-edit-ids"
import { prepareEditorOpenMenu } from "cc-frontend/lib/actions/lesson/LESSON_EDITOR_OPEN_MENU"
import { prepareEditorOperation } from "cc-frontend/lib/actions/lesson/LESSON_EDITOR_OPERATION"
import { useMemo } from "react"
import { useDispatch } from "react-app/hooks/useDispatch"

/**
 * The app end of the editor's analytics port: every event the editor records becomes its own
 * analytics-only action, dispatched as it happens. The editor's failure boundary swallows
 * anything that throws here, so a dispatch failure can never alter an edit.
 */
export function useEditorAnalyticsPort(
  cardStackId: string,
  ids: LessonEditIds,
): EditorAnalyticsPort {
  const dispatch = useDispatch()
  const { planbookId, courseId, dateString } = ids
  return useMemo(
    () => ({
      recordOperation(event) {
        dispatch(prepareEditorOperation({ cardStackId, planbookId, courseId, dateString, event }))
      },
      recordOpenMenu(event) {
        dispatch(prepareEditorOpenMenu({ cardStackId, planbookId, courseId, dateString, event }))
      },
    }),
    [cardStackId, planbookId, courseId, dateString, dispatch],
  )
}

export function reportEditorAnalyticsError(error: unknown): void {
  Sentry.captureException(error)
}
